module.exports = "/_next/static/images/invoice-ticket-tooltip-b6d76e30c2855f6103404a2d7e5f228c.svg";